jQuery(document).ready(function ($) {
    $('#btn__save-info').on('click', function (e) {
        e.preventDefault();

        // Collect form data
        var formData = $('#save_user_info').serializeArray();
        formData.push({ name: 'action', value: 'save_user_info' });

        // AJAX request
        $.ajax({
            type: 'POST',
            url: missjones_data.ajax_url,
            data: formData,
            dataType: 'json',
            beforeSend: function () {
                // Show loading spinner before the AJAX request
                // alert(JSON.stringify(formData));
                jQuery("#btn__save-info").val("Saving...");
            },
            success: function (response) {
                jQuery("#btn__save-info").val("Save");
                showNotification('Profile has been updated!', 'info');
            },
            error: function (error) {
                console.log(error.responseText);
            }
        });
    });
});

jQuery(document).ready(function ($) {
    $('#btn__edit-profile').on('click', function (e) {
        e.preventDefault();

        // Collect form data
        var formData = $('#edit_profile_user').serializeArray();
        formData.push({ name: 'action', value: 'edit_profile_user' });

        // AJAX request
        $.ajax({
            type: 'POST',
            url: missjones_data.ajax_url,
            data: formData,
            dataType: 'json',
            beforeSend: function () {
                // Show loading spinner before the AJAX request
                // alert(JSON.stringify(formData));
                jQuery("#btn__edit-profile").val("Saving...");
            },
            success: function (response) {
                //window.location.reload(true);
                jQuery("#btn__edit-profile").val("save");
                showNotification('Profile has been updated!', 'info');
            },
            error: function (error) {
                console.log(error.responseText);
            }
        });
    });

});

jQuery(document).ready(function () {
    // Hide all tab contents except the first one

    jQuery(".mj-dashboard__tab-content").not(":eq('0')").hide();

    // Handle tab click event
    jQuery(".mj-dashboard__tab").click(function (e) {

        e.preventDefault();
        // Remove active class from all tabs
        jQuery(".mj-dashboard__tab").removeClass("active");

        let tabName = jQuery(this).data('type');

        // Add active class to the clicked tab
        jQuery(".mj-dashboard__tab[data-type=" + tabName + "]").addClass("active");

        // Hide all tab contents
        jQuery(".mj-dashboard__tab-content").hide();

        jQuery(".mj-dashboard__tab-content[data-type=" + tabName + "]").fadeIn();

        // Prevent default link behavior
        return false;
    });
});

jQuery(document).ready(function () {
    const urlParams = new URLSearchParams(window.location.search);
    const menuValue = urlParams.get('menu');

    const tabValue = urlParams.get('tab');

    const menuItems = document.querySelectorAll('.mj-dashboard-menu-item');
    // Find the corresponding menu item and add the 'active' class based on data-id
    jQuery('.mj-dashboard-menu-item').each(function () {
        var dataId = jQuery(this).data('id');
        if (menuValue == dataId) {
            menuItems.forEach(item => item.classList.remove('active'));
            jQuery(this).addClass('active');
        }
    });

    if (tabValue !== null) {
        const tabItems = document.querySelectorAll('.mj-dashboard__tab');

        // Hide all tab contents
        jQuery(".mj-dashboard__tab").removeClass("active");
        jQuery(".mj-dashboard__tab-content").hide();


        // Add active class to the clicked tab
        jQuery(".mj-dashboard__tab[data-type=" + tabValue + "]").addClass("active");

        jQuery(".mj-dashboard__tab-content[data-type=" + tabValue + "]").fadeIn();
    }
});

jQuery(document).ready(function ($) {
    $(document).on('click', '.dashboard-remove-item', function (e) {
        e.preventDefault();

        let itemType = e.target.getAttribute("data-type");
        let postId = e.target.getAttribute("data-id");


        if (itemType == "venue") {
            $warning = "Warning: Proceeding will permanently delete this venue and all associated spaces. This action cannot be undone. Are you sure you want to continue?";

        } else if (itemType == "space") {
            $warning = "Warning: Confirm removal of this space from its venue. This action cannot be undone. Are you sure you want to proceed?";

        } else if (itemType == "supplier") {
            $warning = "Warning: Proceeding will permanently remove this service. This action cannot be undone. Are you sure you want to continue?";

        }

        // Display a yes/no prompt
        var userResponse = window.confirm($warning);
        if (userResponse) {
            // Proceed with the action
            var ajaxData = {
                action: 'dashboard_remove_item', // AJAX action hook
                item_type: itemType,
                post_id: postId
            };

            // AJAX request
            $.ajax({
                type: 'POST',
                url: missjones_data.ajax_url,
                data: ajaxData,
                dataType: 'json',
                beforeSend: function () {
                    // Show loading spinner before the AJAX request
                    // alert(JSON.stringify(formData));

                },
                success: function (response) {
                    console.log(response);
                    if (response.success === true) {
                        showNotification("The item has been removed!", 'error');
                        window.location.reload(true);
                    } else {
                        showNotification("Error on removing the item!", 'error');
                    }
                },
                error: function (error) {
                    console.log(error.responseText);
                }
            });
        } else {
            console.log("User clicked 'Cancel'");
            // Handle the cancellation
        }
    });
});

jQuery(document).ready(function ($) {
    $('#export-venues').on('click', function (e) {
        e.preventDefault();

        // Disable button and show preparing text
        var $button = $(this);
        $button.addClass('--deactive').text('Preparing...');

        // Send AJAX request to export venues
        $.ajax({
            url: missjones_data.ajax_url,
            type: 'POST',
            data: {
                action: 'export_venues_to_csv' // This will hook to your PHP function
            },
            success: function (response) {
                if (response.success) {
                    // Create a temporary link to download the CSV file
                    var a = document.createElement('a');
                    a.href = response.data.file_url;
                    a.download = response.data.file_url.split('/').pop(); // Extract the file name from the URL
                    document.body.appendChild(a);
                    a.click();
                    document.body.removeChild(a);

                    // Show success message
                    $button.text('Export Venues').removeClass('--deactive');
                    showNotification('Export Successful! Downloading the CSV file!...', 'info');
                } else {
                    $button.text('Export Venues').removeClass('--deactive');
                    showNotification('Export Failed!', 'error');
                }
            },
            error: function () {
                $button.text('Export Venues').removeClass('--deactive');
                showNotification('Export Failed!', 'error');
            }
        });
    });
});

jQuery(document).ready(function ($) {
    $('#export-suppliers').on('click', function (e) {
        e.preventDefault();

        // Disable button and show preparing text
        var $button = $(this);
        $button.addClass('--deactive').text('Preparing...');

        // Send AJAX request to export suppliers
        $.ajax({
            url: missjones_data.ajax_url,
            type: 'POST',
            data: {
                action: 'export_suppliers_to_csv' // This will hook to your PHP function
            },
            success: function (response) {
                if (response.success) {
                    // Create a temporary link to download the CSV file
                    var a = document.createElement('a');
                    a.href = response.data.file_url;
                    a.download = response.data.file_url.split('/').pop(); // Extract the file name from the URL
                    document.body.appendChild(a);
                    a.click();
                    document.body.removeChild(a);

                    // Show success message
                    $button.text('Export Suppliers').removeClass('--deactive');
                    showNotification('Export Successful! Downloading the CSV file!...', 'info');
                } else {
                    $button.text('Export Suppliers').removeClass('--deactive');
                    showNotification('Export Failed!', 'error');
                }
            },
            error: function () {
                $button.text('Export Suppliers').removeClass('--deactive');
                showNotification('Export Failed!', 'error');

            }
        });
    });
});

jQuery(document).ready(function ($) {
    $('#export-venue-taxonomies').on('click', function (e) {
        e.preventDefault();

        // Disable button and show preparing text
        var $button = $(this);
        $button.addClass('--deactive').text('Preparing...');

        // Send AJAX request to export venue taxonomies
        $.ajax({
            url: missjones_data.ajax_url,
            type: 'POST',
            data: {
                action: 'export_venue_taxonomies_to_csv' // Hook to your PHP function
            },
            success: function (response) {
                if (response.success) {
                    // Create a temporary link to download the CSV file
                    var a = document.createElement('a');
                    a.href = response.data.file_url; // The file URL returned from PHP
                    a.download = response.data.file_url.split('/').pop(); // Extract the file name from the URL
                    document.body.appendChild(a);
                    a.click();
                    document.body.removeChild(a);

                    // Show success message
                    $button.text('Export Venue Taxonomies').removeClass('--deactive');
                    showNotification('Export Successful! Downloading the CSV file!...', 'info');
                } else {
                    $button.text('Export Venue Taxonomies').removeClass('--deactive');
                    showNotification('Export Failed!', 'error');
                }
            },
            error: function () {
                $button.text('Export Venue Taxonomies').removeClass('--deactive');
                showNotification('Export Failed!', 'error');
            }
        });
    });
});

jQuery(document).ready(function ($) {
    $('#export-supplier-taxonomies').on('click', function (e) {
        e.preventDefault();

        // Disable button and show preparing text
        var $button = $(this);
        $button.addClass('--deactive').text('Preparing...');

        // Send AJAX request to export supplier taxonomies
        $.ajax({
            url: missjones_data.ajax_url,
            type: 'POST',
            data: {
                action: 'export_supplier_taxonomies_to_csv' // Hook to your PHP function
            },
            success: function (response) {
                if (response.success) {
                    // Create a temporary link to download the CSV file
                    var a = document.createElement('a');
                    a.href = response.data.file_url; // The file URL returned from PHP
                    a.download = response.data.file_url.split('/').pop(); // Extract the file name from the URL
                    document.body.appendChild(a);
                    a.click();
                    document.body.removeChild(a);

                    // Show success message
                    $button.text('Export Supplier Taxonomies').removeClass('--deactive');
                    showNotification('Export Successful! Downloading the CSV file!...', 'info');
                } else {
                    $button.text('Export Supplier Taxonomies').removeClass('--deactive');
                    showNotification('Export Failed!', 'error');
                }
            },
            error: function () {
                $button.text('Export Supplier Taxonomies').removeClass('--deactive');
                showNotification('Export Failed!', 'error');
            }
        });
    });
});





// js/my-custom-plugin.js
jQuery(document).ready(function ($) {
    $('#change-users-role').on('click', function (e) {
        e.preventDefault();

        if (!confirm("Are you sure you want to update show all users?")) {
            return;
        }

        $.ajax({
            url: missjones_data.ajax_url,
            type: 'POST',
            data: {
                action: 'change_users_role_callback',
            },
            success: function (response) {
                if (response.success) {
                    let usersList = response.data.users;
                    let totalCount = usersList.length;
                    let output = `<p>Following users were affected: (total: ${totalCount})</p><ul>`;

                    // Loop through the users and append their info to the report
                    $.each(usersList, function (index, user) {
                        output += `<li>${user.email} (${user.roles})</li>`;
                    });

                    output += '</ul>';
                    $('#users_report').html(output);

                    // Automatically download the generated CSV file
                    if (response.data.file_url) {
                        alert("Download is ready");
                        let downloadLink = document.createElement('a');
                        downloadLink.href = response.data.file_url;
                        downloadLink.download = response.data.file_url.split('/').pop(); // Get the file name from URL
                        document.body.appendChild(downloadLink);
                        downloadLink.click();
                        document.body.removeChild(downloadLink); // Clean up
                    }
                } else {
                    $('#users_report').html('<p>Error: ' + response.data.message + '</p>');
                }
            },
            error: function (xhr, status, error) {
                $('#users_report').html('<p>Something went wrong: ' + error + '</p>');
            }
        });
    });
});

